export const loadingData = (bool) => ({
  type: 'LOADING_DATA',
  bool
})
